import { ref, uploadString, getDownloadURL, deleteObject } from 'firebase/storage';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import {
  firebaseApp,
  getFirebaseStorage,
  getFirestoreDb,
  isFirebaseConfigured,
} from './config';

function slugTitle(title) {
  return String(title || 'image')
    .replace(/[^a-zA-Z0-9-_]+/g, '-')
    .slice(0, 80);
}

/**
 * Upload a data-URL image to Storage and create a Firestore `gallery` document.
 * @returns {{ id: string, title: string, category: string, imageUrl: string, storagePath: string }}
 */
export async function uploadGalleryEntry({ title, category, dataUrl }) {
  if (!isFirebaseConfigured() || !firebaseApp) {
    throw new Error('Firebase not configured');
  }
  const storage = getFirebaseStorage();
  const db = getFirestoreDb();
  if (!storage || !db) {
    throw new Error('Firebase Storage or Firestore unavailable');
  }

  const path = `gallery/${Date.now()}_${slugTitle(title)}.jpg`;
  const storageRef = ref(storage, path);
  await uploadString(storageRef, dataUrl, 'data_url');
  const imageUrl = await getDownloadURL(storageRef);

  const docRef = await addDoc(collection(db, 'gallery'), {
    title: title || 'Untitled',
    category: category || 'Living',
    imageUrl,
    storagePath: path,
    createdAt: serverTimestamp(),
  });

  return {
    id: docRef.id,
    title: title || 'Untitled',
    category: category || 'Living',
    imageUrl,
    storagePath: path,
  };
}

export async function deleteGalleryStorageFile(storagePath) {
  if (!isFirebaseConfigured() || !storagePath) return;
  const storage = getFirebaseStorage();
  if (!storage) return;
  await deleteObject(ref(storage, storagePath));
}

/** Save an external image URL into Firestore `gallery` (no Storage upload). */
export async function saveGalleryLinkDocument({ title, category, imageUrl }) {
  if (!isFirebaseConfigured()) {
    throw new Error('Firebase not configured');
  }
  const db = getFirestoreDb();
  if (!db) {
    throw new Error('Firestore unavailable');
  }
  const docRef = await addDoc(collection(db, 'gallery'), {
    title: title || 'Untitled',
    category: category || 'Living',
    imageUrl,
    createdAt: serverTimestamp(),
  });
  return {
    id: docRef.id,
    title: title || 'Untitled',
    category: category || 'Living',
    imageUrl,
  };
}
